import React, { FunctionComponent, useState } from 'react';
import Icon from '../../components/Icon';
import { IPosition } from '../../common/models/position/IPosition';
import RegularButton from '../../components/RegularButton';
import MergePositions from '../MergePositions';
import ModalWindow from '../../components/ModalWindow';

interface IProps {
  positions: IPosition[];
}

type PositionBulkAction = 'merge';

const PositionsBulkActions: FunctionComponent<IProps> = ({ positions }) => {
  const [activeAction, setActiveAction] = useState<PositionBulkAction | null>(null);

  const onHide = () => setActiveAction(null);

  return (
    <div className="bulk-actions">
      <RegularButton
        variant="tertiary"
        disabled={positions.length < 2 || positions.length > 5}
        textIntlId="iconButtonLable.merge"
        defaultMessage="Merge"
        icon={<Icon icon="merge" />}
        onClick={() => setActiveAction('merge')}
      />
      <ModalWindow
        isShown={activeAction === 'merge'}
        onHide={onHide}
        contentClassName="big-modal modal-wrapper"
      >
        <MergePositions onHide={onHide} positions={positions} />
      </ModalWindow>
    </div>
  );
};

export default PositionsBulkActions;
